export const PROJECT_ID = 'PROJECT_ID'
export const PROJECT_NAME = 'PROJECT_NAME'
export const PROJECT_CODE = 'PROJECT_CODE'
export const PROJECT_CONTACT_NAME = 'PROJECT_CONTACT_NAME'
export const PROJECT_CONTACT_TEL1 = 'PROJECT_CONTACT_TEL1'
export const PROJECT_CONTACT_TEL2 = 'PROJECT_CONTACT_TEL2'
export const PROJECT_CONTACT_EMAIL = 'PROJECT_CONTACT_EMAIL'
export const PROJECT_CONTACT_ADRESSE = 'PROJECT_CONTACT_ADRESSE'
export const PROJECT_CONTACT_COMPLEMENT_ADRESSE = 'PROJECT_CONTACT_COMPLEMENT_ADRESSE'
export const PROJECT_CONTACT_CODE_POSTAL = 'PROJECT_CONTACT_CODE_POSTAL'
export const PROJECT_CONTACT_VILLE = 'PROJECT_CONTACT_VILLE'
export const PROJECT_CONTACT_DEPARTEMENT = 'PROJECT_CONTACT_DEPARTEMENT'
export const PROJECT_CONTACT_SOCIETE = 'PROJECT_CONTACT_SOCIETE'
export const PROJECT_CONTACT_TYPE_OPERATION = 'PROJECT_CONTACT_TYPE_OPERATION'
export const PROJECT_CONTACT_TYPE_ERP = 'PROJECT_CONTACT_TYPE_ERP'
export const PROJECT_CONTACT_CLIENT = 'PROJECT_CONTACT_CLIENT'
export const PROJECT_CONTACT_ETAT = 'PROJECT_CONTACT_ETAT'
export const PROJECT_CONTACT_NUMERO_AFFAIRE = 'PROJECT_CONTACT_NUMERO_AFFAIRE'
export const LIST_PROJETS = 'LIST_PROJETS'



// WEBPACK FOOTER //
// ./src/store/modules/projectForm/mutation_types.js